import AnalyticsHelpers from './analyticsHelper';


let analyticsHelpers = new AnalyticsHelpers('Login', 'sitecore-challenger-iol', '9.0.3', 'challenger-iol');


const analyticsPlugins = (log) => {
  return {
    storeWatcher: (store) => {
      // called when the store is initialized
      store.subscribe((mutation, state) => {
        // called after every mutation.
        // The mutation comes in the format of `{ type, payload }`.
      });
    },
    routerWatcher: (routeName) => {
      //Called when the route is updated
      try {
        analyticsHelpers.setRouteChange(routeName);
        analyticsHelpers.setUserData();
        analyticsHelpers.triggerAnalyticsEvent('page-view');
        log.debug('Analytics: page-view: ' + routeName);
      } catch (e) {
        log.error(e);
      }
    },
    customWatcher: (eventName, data) => {
      try {
        analyticsHelpers.setCustomData(data);
        analyticsHelpers.setUserData();
        analyticsHelpers.triggerAnalyticsEvent(eventName);
      } catch (e) {
        log.error(e);
      }
    }
  }

};

export default analyticsPlugins;
